export default __webpack_public_path__ + "media/amber.34302361.jpg";